import { useState } from 'react';
import { authContainer } from '../../di/container';

export function useForgotPassword() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const forgotPassword = async (email: string) => {
    setIsLoading(true);
    setError(null);
    try {
      await authContainer.repository.forgotPassword({ email });
      setSuccess(true);
    } catch (err) {
      setError(
        err instanceof Error ? err.message : 'Failed to send reset email',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return { forgotPassword, isLoading, error, success };
}
